import axios from 'axios';

let authToken = null;

export function setAuthToken(token) {
  authToken = token;
}

const api = axios.create({
  baseURL: 'https://app.olympicbarbacena.com.br/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const path = window.location.pathname;
    if (error.response?.status === 401 && path !== '/login' && !path.startsWith('/reset-password')) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
